import { Homepage, Login, History, GeoData, Reports, AdminUsers, GeometraSquadra, ChangePassword, RealtimeMap, ModificaLavoro, ModificaSegnalazione, AdminCreateWork, AdminAssignedJobs, AdminCalendar, AdminStrade, AdminInterventi, AdminCompanies, AdminTeamTypes, AdminAssets, AdminOperators, AdminCommessa, AdminModules } from "@/pages";
import { shouldRedirectAdminAssets } from "@/utils/assetSchema";

const routes = [
  { path: '/home', name: 'home', component: Homepage },
  { path: '/', name: 'login', component: Login },
  {
      path: '/history/:scope',
      name: 'history',
      component: History
    },
  { path: '/geo-data', name: 'geo-data', component: GeoData },
  { path: '/reports', name: 'reports', component: Reports },
  { path: '/admin/users', name: 'admin-users', component: AdminUsers },
  { path: '/admin/geometra-squadra', name: 'geometra-squadra', component: GeometraSquadra },
  { path: '/profilo/cambia-password', name: 'change-password', component: ChangePassword },
  { path: '/mappa', name: 'realtime-map', component: RealtimeMap },
  { path: '/history/lavori/:uuid/modifica', name: 'modifica-lavoro', component: ModificaLavoro },
  { path: '/history/segnalazioni/:uuid/modifica', name: 'modifica-segnalazione', component: ModificaSegnalazione },
  { path: '/admin/lavoro/nuovo', name: 'admin-create-work', component: AdminCreateWork },
  { path: '/admin/lavori/assegnati', name: 'admin-assigned-jobs', component: AdminAssignedJobs },
  { path: '/admin/calendario', name: 'admin-calendar', component: AdminCalendar },
  { path: '/admin/strade', name: 'admin-strade', component: AdminStrade },
  { path: '/admin/interventi', name: 'admin-interventi', component: AdminInterventi },
  { path: '/admin/aziende', name: 'admin-companies', component: AdminCompanies },
  { path: '/admin/squadre/tipologie', name: 'admin-team-types', component: AdminTeamTypes },
  {
    path: '/admin/assets',
    name: 'admin-assets',
    component: AdminAssets,
    beforeEnter: (to, from, next) => {
      const tipologia = localStorage.getItem('tipologia');
      // Solo Admin_Azienda (B, ed eventualmente A) viene rediretto al tab consolidato.
      if (shouldRedirectAdminAssets(tipologia)) {
        next({ name: 'admin-modules', query: { tab: 'assets' } });
      } else {
        // Developer (D) e ogni altro caso: route invariata.
        next();
      }
    }
  },
  { path: '/admin/operatori', name: 'admin-operators', component: AdminOperators },
  { path: '/admin/commessa', name: 'admin-commessa', component: AdminCommessa },
  { path: '/admin/moduli', name: 'admin-modules', component: AdminModules },
]

export default routes;